// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum HeaterOffReason {
    Requested = 'Requested',
    FanIsOff = 'FanIsOff',
    LayerTemperatureAboveLimit = 'LayerTemperatureAboveLimit',
    PlenumTempAboveLimit = 'PlenumTempAboveLimit',
    Unknown = 'Unknown',
}
export default HeaterOffReason;
